import { OTHER_NODES_LABEL } from "@faire/help-center-self-serve/shared/other-node";
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Settings } from "@faire/web/slate/icons/foundation/Settings";
import React from "react";
import { AccountEmailIA } from "../instantAnswers/myAccount-accountEmail";
import { ContactInfoIA } from "../instantAnswers/myAccount-contactInfo";
import { EmailNotificationsIA } from "../instantAnswers/myAccount-emailNotifications";
import { LinkingPosIA } from "../instantAnswers/myAccount-linkingPos";
import { ManageTeamsIA } from "../instantAnswers/myAccount-manageTeams";
import { MultifactorAuthIA } from "../instantAnswers/myAccount-multifactorAuth";
import { resetOrUpdatePassword } from "../instantAnswers/myAccount-resetOrUpdatePassword";
import { ShippingAddressIA } from "../instantAnswers/myAccount-shippingAddress";
import { TroubleshootingAndOtherPOSIA } from "../instantAnswers/myAccount-troubleshootingAndOtherPos";
import { UnlinkingPosIA } from "../instantAnswers/myAccount-unlinkingPos";
import { UpdateAccountTypeIA } from "../instantAnswers/myAccount-updateAccountType";
import { VatAndTaxIdentifiersIA } from "../instantAnswers/myAccount-vatAndTaxIdentifiers";
import { PoBoxIA } from "../instantAnswers/ordersAndShipping-poBox";
import { BillingAddressIA } from "../instantAnswers/shared-billingAddress";
import { VatAndTaxIdentifiersVisibilityFn } from "../visibilityFunctions/vatAndTaxIdentifiersVisibilityFn";
export var useSettingsRetailerNodes = function useSettingsRetailerNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    Settings: {
      id: "Settings",
      label: strictLocalize({
        id: "6Zkgy6",
        defaultMessage: [{
          "type": 0,
          "value": "Paramètres"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Settings, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      children: ["AccountInformation", "ManageTeam", "PosIntegration"],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "a7Kuyu",
        defaultMessage: [{
          "type": 0,
          "value": "Problème de paramètres"
        }]
      })
    },
    AccountInformation: {
      id: "AccountInformation",
      label: strictLocalize({
        id: "4mJqbh",
        defaultMessage: [{
          "type": 0,
          "value": "Informations du compte"
        }]
      }),
      children: ["LoginAndSecurity", "NotificationPreferences", "Addresses", "ContactInformation", "Tax Information", "UpdateAccountType", "OtherAccountInformation"],
      level: 2
    },
    ManageTeam: {
      id: "ManageTeam",
      label: strictLocalize({
        id: "puPU5O",
        defaultMessage: [{
          "type": 0,
          "value": "Gérer l'équipe"
        }]
      }),
      articles: [articles.Account.MANAGE_TEAMS],
      instantAnswer: ManageTeamsIA(strictLocalize),
      level: 2
    },
    PosIntegration: {
      id: "PosIntegration",
      label: strictLocalize({
        id: "dVGEcP",
        defaultMessage: [{
          "type": 0,
          "value": "Intégration au TPV"
        }]
      }),
      children: ["LinkPos", "TroubleshootPosIntegration", "UnlinkPos", "OtherPosIntegration"],
      level: 2
    },
    LoginAndSecurity: {
      id: "LoginAndSecurity",
      label: strictLocalize({
        id: "JWHjBf",
        defaultMessage: [{
          "type": 0,
          "value": "Identifiant et sécurité"
        }]
      }),
      children: ["LoginEmail", "ResetOrUpdatePassword", "MultifactorAuth"],
      level: 3
    },
    NotificationPreferences: {
      id: "NotificationPreferences",
      label: strictLocalize({
        id: "EMfybq",
        defaultMessage: [{
          "type": 0,
          "value": "Préférences de notification"
        }]
      }),
      articles: [articles.Account.EMAIL_NOTIFICATIONS],
      instantAnswer: EmailNotificationsIA(strictLocalize),
      level: 3
    },
    Addresses: {
      id: "Addresses",
      label: strictLocalize({
        id: "9fHrO6",
        defaultMessage: [{
          "type": 0,
          "value": "Adresses"
        }]
      }),
      children: ["BillingAddress", "ShippingAddress", "RestrictedAddresses"],
      level: 3
    },
    ContactInformation: {
      id: "ContactInformation",
      label: strictLocalize({
        id: "jkqM2m",
        defaultMessage: [{
          "type": 0,
          "value": "Coordonnées"
        }]
      }),
      instantAnswer: ContactInfoIA(strictLocalize),
      level: 3
    },
    TaxInformation: {
      id: "TaxInformation",
      label: strictLocalize({
        id: "IbkQGM",
        defaultMessage: [{
          "type": 0,
          "value": "Informations fiscales"
        }]
      }),
      children: ["TaxIDs"],
      level: 3
    },
    UpdateAccountType: {
      id: "UpdateAccountType",
      label: strictLocalize({
        id: "3Gxkjp",
        defaultMessage: [{
          "type": 0,
          "value": "Changer le type de compte"
        }]
      }),
      instantAnswer: UpdateAccountTypeIA(strictLocalize),
      level: 3
    },
    OtherAccountSettings: {
      id: "OtherAccountSettings",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.GettingStarted.RESELLER_ID, articles.GettingStarted.BRICK_AND_MORTAR, articles.MyOrders.BUSINESS_PROFILE],
      level: 3
    },
    LinkPos: {
      id: "LinkPos",
      label: strictLocalize({
        id: "pkLx+A",
        defaultMessage: [{
          "type": 0,
          "value": "Associer le TPV"
        }]
      }),
      articles: [articles.MyOrders.SYNC_SQUARE_POS],
      instantAnswer: LinkingPosIA(strictLocalize),
      level: 3
    },
    TroubleshootPosIntegration: {
      id: "TroubleshootPosIntegration",
      label: strictLocalize({
        id: "b1zuby",
        defaultMessage: [{
          "type": 0,
          "value": "Résoudre les problèmes d'intégration au TPV"
        }]
      }),
      articles: [articles.MyOrders.SYNC_SQUARE_POS],
      instantAnswer: TroubleshootingAndOtherPOSIA(strictLocalize),
      level: 3
    },
    UnlinkPos: {
      id: "UnlinkPos",
      label: strictLocalize({
        id: "4ab+jx",
        defaultMessage: [{
          "type": 0,
          "value": "Dissocier le TPV"
        }]
      }),
      articles: [articles.MyOrders.SYNC_SQUARE_POS],
      instantAnswer: UnlinkingPosIA(strictLocalize),
      level: 3
    },
    OtherPosIntegration: {
      id: "OtherPosIntegration",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.MyOrders.SYNC_SQUARE_POS],
      instantAnswer: TroubleshootingAndOtherPOSIA(strictLocalize),
      level: 3
    },
    ResetOrUpdatePassword: {
      id: "ResetOrUpdatePassword",
      label: strictLocalize({
        id: "JDOVsm",
        defaultMessage: [{
          "type": 0,
          "value": "Réinitialisation ou mise à jour du mot de passe"
        }]
      }),
      articles: [articles.FAQ.RESETTING_PASSWORD, articles.FAQ.FAIRE_ACCOUNT_SECURITY],
      instantAnswer: resetOrUpdatePassword(strictLocalize),
      level: 4
    },
    LoginEmail: {
      id: "LoginEmail",
      label: strictLocalize({
        id: "/ULOia",
        defaultMessage: [{
          "type": 0,
          "value": "E-mail de connexion"
        }]
      }),
      articles: [articles.Account.ACCOUNT_EMAIL],
      instantAnswer: AccountEmailIA(strictLocalize),
      level: 4
    },
    MultifactorAuth: {
      id: "MultifactorAuth",
      label: strictLocalize({
        id: "k8NE3+",
        defaultMessage: [{
          "type": 0,
          "value": "Authentification multifacteur"
        }]
      }),
      instantAnswer: MultifactorAuthIA(strictLocalize),
      level: 4
    },
    BillingAddress: {
      id: "BillingAddress",
      label: strictLocalize({
        id: "z5ti4q",
        defaultMessage: [{
          "type": 0,
          "value": "Adresse de facturation"
        }]
      }),
      articles: [articles.PaymentsAndInvoices.HOW_DO_I_CHANGE_MY_BILLING_ADDRESS],
      instantAnswer: BillingAddressIA(strictLocalize),
      level: 4
    },
    ShippingAddress: {
      id: "ShippingAddress",
      label: strictLocalize({
        id: "EPdy0V",
        defaultMessage: [{
          "type": 0,
          "value": "Adresse de livraison"
        }]
      }),
      articles: [articles.FulfillingOrders.SHIPPING_ADDRESS],
      instantAnswer: ShippingAddressIA(strictLocalize),
      level: 4
    },
    RestrictedAddresses: {
      id: "RestrictedAddresses",
      label: strictLocalize({
        id: "Pn3h0F",
        defaultMessage: [{
          "type": 0,
          "value": "Adresses restreintes"
        }]
      }),
      articles: [articles.FulfillingOrders.SHIPPING_ADDRESS],
      instantAnswer: PoBoxIA(strictLocalize),
      level: 4
    },
    TaxIDs: {
      id: "TaxIDs",
      label: strictLocalize({
        id: "XLEu+Y",
        defaultMessage: [{
          "type": 0,
          "value": "Identifiants fiscaux"
        }]
      }),
      articles: [articles.ImportFeesAndDuties.VAT],
      instantAnswer: VatAndTaxIdentifiersIA(strictLocalize),
      isNodeVisible: VatAndTaxIdentifiersVisibilityFn,
      level: 4
    }
  };
};